/* eslint-disable default-param-last */
import axios from 'axios';

import apiBaseUrl from '../../config/apiBaseUrl';

import { processApiResponse } from '../helper/processApiResponse';

export const entryAPI = {
  Post(
    params = {
      _id: '',
      sessionToken: '',
      log: {},
    },
    setApiProcessingPool = null,
    setApiDonePool = null,
    config = {},
  ) {
    const apiRoute = `${apiBaseUrl}/api/log/entry/post`;
    return processApiResponse(
      axios.post(apiRoute, params, config),
      apiRoute,
      setApiProcessingPool,
      setApiDonePool,
    );
  },
};
